import Box from "@mui/material/Box";
import Titles from "../../../shared/components/Titles/Titles";
import CardGrid from "../../../shared/components/common/ui/CardGrid";

const TemplateAddContent = ({ templateData, isLoading = false }) => {

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: { sm: "calc(100vh - 100px)" },
        paddingBottom: 10,
      }}
    >
      <Box sx={{ padding: { xs: "30px", sm: "30px" } }}>
        <Titles
          styles={{ fontSize: { xs: "20px", sm: "24px" } }}
          color="#848484"
        >
          Qual modelo deseja adicionar?
        </Titles>

        <CardGrid
          data={templateData}
          showText
          loading={isLoading}
          loadingCount={1}
          neutralArrow
        />

      </Box>
    </Box>
  );
};

export default TemplateAddContent;
